import React from 'react';

import SimpleHelmet from '../components/SimpleHelmet';
import Layout from '../components/Layout';

import Hero from '../views/Hero';
import ContentBlock from '../views/ContentBlock';
import SimpleButton from '../components/SimpleButton';

import styles from './BioPage.module.scss';

export const BioPageTemplate = ({
  headingSmall,
  headingBig,
  image,
  content,
  pressKitLabel,
  pressKit
}) => {
  return (
    <>
      <Hero image={image}>
        <h1 className={styles.title}>
          <span className={styles.titleSmall}>{headingSmall}</span>
          <span className={styles.titleBig}>{headingBig}</span>
        </h1>
      </Hero>
      <ContentBlock content={content} />
      <div className={styles.buttonsWrapper}>
        <div className={styles.buttons}>
          <a target="_blank" href={pressKit}>
            <SimpleButton title={pressKitLabel} />
          </a>
        </div>
      </div>
    </>
  );
};

BioPageTemplate.propTypes = {};

const BioPage = ({ data }) => {
  const { frontmatter, html, fields } = data.markdownRemark;

  return (
    <Layout absoluteMenu>
      <SimpleHelmet
        seoTitle={frontmatter.seoTitle}
        seoDescription={frontmatter.seoDescription}
        seoUrl={fields.slug}
      />
      <BioPageTemplate
        headingSmall={frontmatter.headingSmall}
        headingBig={frontmatter.headingBig}
        image={frontmatter.image}
        pressKitLabel={frontmatter.pressKitLabel}
        pressKit={frontmatter.pressKit.publicURL}
        content={html}
      />
    </Layout>
  );
};

export default BioPage;

export const pageQuery = graphql`
  query BioPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "bio-page" } }) {
      html
      fields {
        slug
      }
      frontmatter {
        headingSmall
        headingBig
        seoTitle
        seoDescription
        pressKitLabel
        pressKit {
          publicURL
        }
        image {
          childImageSharp {
            fluid(maxWidth: 1000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
